// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mgy5","content":"styles_content__1c5ko"};